module.exports = __webpack_public_path__ + "static/media/whichThinnerChoiceWarfarin.bf0025fd.mp3";